<div class="p-4 md:p-6">
  <h2 mat-dialog-title class="text-3xl font-bold text-gray-800 mb-4">
    {{ 'CHANGE_PLAN.TITLE' | translate }}
  </h2>

  <mat-dialog-content>
    <ui-payment-table 
      [currentPlanLookupKey]="currentPlanLookupKey"
      (planSelect)="onPlanSelect($event)">
    </ui-payment-table>

    <div *ngIf="isLoading" class="loading-overlay">
      <mat-spinner></mat-spinner>
      <p>{{ 'CHANGE_PLAN.LOADING' | translate }}</p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="mt-6 border-t pt-4">
    <button mat-button (click)="dialogRef.close()">
      {{ 'ACTION.CANCEL' | translate }}
    </button>
  </mat-dialog-actions>
</div>